import { SourceAnalysisOrganizerFormData } from "@/types/models/Exportables.interface";

export function getOptionalFieldsList(setiIdentifier: string | undefined) {
  const SOURCE_ANALYSIS_OPTIONAL_FIELDS: (keyof SourceAnalysisOrganizerFormData)[] =
    [
      "intended_audience",
      "world_events",
      "evidence_of_bias",
      "excluded_topics",
      "reliability",
      "conclusion",
    ];

  switch (setiIdentifier) {
    case "primary_source_analysis":
      return SOURCE_ANALYSIS_OPTIONAL_FIELDS;
    default:
      return [];
  }
}
